export default "__VITE_ASSET__D$A_2KVa__"